import React from "react";
import WeeklyReport from "app/modules/reports/weekly-report";

export default function WeeklyReportPage() {
    return <WeeklyReport/>
}